<template>
    <div class="ester-synthese-mechanismus">
        <img
            src="@/assets/img/stoffe/ester/synthese.gif"
            alt="Estersynthese"
            title="Estersynthese"
        />
        <small
            ><a
                href="https://de.serlo.org/chemie/reaktionen/arten-reaktionen/veresterung"
                target="_blank"
                >Quelle</a
            ></small
        >
    </div>
</template>

<script>
export default {
    name: 'ester-synthese-mechanismus',
};
</script>
